<template>
  <base-box title="Konfiguration">
    <h5 class="mb-0" style="margin-top: -0.5rem">
      {{ menu.attributes.name }}
    </h5>
    <small class="text-muted">
      {{ menuTitle }}
    </small>
    <div
      v-if="menu.attributes.absolute_logo_path"
      class="w-100 p-5"
      :style="'background: url(' + menu.attributes.absolute_logo_path + ') no-repeat center / contain;'"
    ></div>
    <div class="text-muted">
      <strong>Seiten</strong>: {{ menu.attributes.data.pages }}<br />
      <strong>Format</strong>: {{ formats[menu.attributes.data.format] }}<br />
      <strong>Bindung</strong>: {{ bindings[menu.attributes.data.binding] }}<br />
      <strong>Cellophanierung</strong>: {{ laminations[menu.attributes.data.lamination] }}<br />
      <template v-if="bindings[menu.attributes.data.binding] === 'Faltblatt 4 Seiten'">
        <strong>Material</strong>: 300g/m² Bilderdruckpapier<br />
      </template>
      <template v-else-if="bindings[menu.attributes.data.binding] === '6-Seiter'">
        <strong>Material</strong>: Umschlag: 250g/m² Bilderdruckpapier <br />
      </template>
      <template v-else>
        <strong>Material</strong>: Umschlag: 300g/m² Bilderdruckpapier, Inhalt: 200g/m² Bilderdruckpapier <br />
      </template>
      <strong style="color: #212529">Voraussichtliches Lieferdatum</strong>: {{ deliveryDate }} (7 Werktage)<br />
    </div>
    <div class="form-floating mt-1 mb-1">
      <select class="form-select p-3" name="printrun" data-attribute="data" @change="$emit('update:data', $event)">
        <option
          v-for="(value, index) in menu.attributes.prices"
          :key="index"
          :value="value.printrun"
          :selected="value.printrun == menu.attributes.data.printrun"
        >
          {{ value.printrun }} Stück - {{ formatPrice(value.price) }}
        </option>
      </select>
      <label>Auflage</label>
    </div>

    <div v-if="menu.attributes.can_use_free_order && !menu.attributes.data.voucher" class="checkbox mb-3">
      <label class="d-flex gap-2">
        <input v-model="freeOrder" type="checkbox" name="freeOrder" data-attribute="data" @change="clickFreeOrder" />
        <div class="check"></div>
        <span>Möchten Sie Ihre jährliche einmalige Gratis-Bestellung einlösen?</span>
      </label>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <strong>Preis <small>(Netto)</small></strong>
      <span>{{ menu.attributes.subtotal }}</span>
    </div>

    <template v-if="menu.attributes.data.freeOrder && menu.attributes.can_use_free_order">
      <div class="d-flex align-items-center justify-content-between">
        <strong>Jährliche einmalige Gratis-Bestellung</strong>
        <span class="w-100 text-end text-primary">
          <span>- {{ menu.attributes.rebate }}</span>
        </span>
      </div>
      <div v-if="!menu.errors?.data?.voucher" class="d-flex align-items-center justify-content-between">
        <strong>Zwischensumme</strong>
        <span class="w-100 text-end">{{ menu.attributes.price }}</span>
      </div>
    </template>
    <template v-else-if="menu.attributes.data.voucher">
      <div class="d-flex align-items-center justify-content-between">
        <strong>
          Gutschein
          <small class="d-block text-nowrap"> ({{ menu.attributes.data.voucher }}) </small>
        </strong>
        <button
          type="button"
          class="btn btn-sm border text-muted hover:text-primary bg-white mx-2"
          @click="$emit('update:data', { name: 'voucher', value: null })"
        >
          <i class="bi bi-trash-fill"></i>
        </button>
        <span class="w-100 text-end text-primary">
          <span v-if="!menu.errors?.data?.voucher">- {{ menu.attributes.rebate }}</span>
        </span>
      </div>
      <div v-if="menu.errors?.data?.voucher" class="invalid-feedback d-block" role="alert">
        <strong v-for="(error, index) in menu.errors?.data?.voucher" :key="index"> {{ error }}&nbsp; </strong>
        <strong>Bitte löschen Sie ihn um fortzufahren.</strong>
      </div>
      <div v-if="!menu.errors?.data?.voucher" class="d-flex align-items-center justify-content-between">
        <strong>Zwischensumme</strong>
        <span class="w-100 text-end">{{ menu.attributes.price }}</span>
      </div>
    </template>
    <!--    <div v-else-if="!freeOrder || !menu.attributes.can_use_free_order" class="position-relative my-2">
      <div class="form-floating">
        <input
          id="voucher"
          ref="voucher"
          class="form-control"
          :class="{ 'is-invalid': menu.errors?.data?.voucher }"
          type="text"
          name="voucher"
          placeholder="Gutscheincode"
          style="padding-right: 6.5rem"
          :value="menu.attributes.data.voucher"
        />
        <label for="voucher">Gutscheincode</label>
      </div>
      <button
        class="btn btn-secondary text-white position-absolute"
        type="button"
        style="top: 50%; right: 0.5rem; transform: translateY(-50%)"
        @click="$emit('update:data', { name: 'voucher', value: voucher.value })"
      >
        einlösen
      </button>
</div> -->
    <div class="d-flex align-items-center justify-content-between">
      <strong>Mehrwertsteuer <small>(20,00%)</small></strong>
      <span class="text-end">{{ menu.attributes.vat }} </span>
    </div>
    <hr class="my-1" />
    <h5 class="d-flex align-items-center justify-content-between mb-0">
      <strong>Rechnungsbetrag <small>(brutto)</small></strong>
      <span>{{ menu.attributes.total }}</span>
    </h5>
  </base-box>
</template>

<script>
import { computed, ref } from 'vue';

export default {
  props: {
    menu: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:data', 'update:voucher'],
  setup(props, { emit }) {
    const bindings = {
      folded: 'Faltblatt 4 Seiten',
      clip: 'Klammerheftung',
      'wireo-red': 'Ringbindung (rot)',
      'wireo-black': 'Ringbindung (schwarz)',
      'wireo-silver': 'Ringbindung (silber)',
      'wireo-white': 'Ringbindung (weiß)',
      sixpager: '6-Seiter',
    };
    const formats = {
      A4: 'Din A4 (297 x 210 mm)',
      A5: 'Din A5 (210 x 149 mm)',
      DL: 'Din Lang (210 x 105 mm)',
      SP: 'DL (99 x 210mm)',
    };
    const laminations = {
      matte: 'matt',
      glossy: 'glänzend',
    };
    const menuTitle = computed(() =>
      ((props.menu.attributes.title ?? '') + ' - ' + (props.menu.attributes.subtitle ?? '')).replace(
        /^\s*-\s*|\s*-\s*$/g,
        ''
      )
    );
    const deliveryDate = computed(() => {
      let date = new Date();
      let workingDays = 7;
      let isWorkingDay = true;

      while (workingDays > 0 || !isWorkingDay) {
        date.setDate(date.getDate() + 1);

        if (date.getDay() !== 0 && date.getDay() !== 6) {
          workingDays--;
          isWorkingDay = true;
        } else {
          isWorkingDay = false;
        }
      }

      return date.getDate() + '. ' + (date.getMonth() + 1) + '. ' + date.getFullYear();
    });
    const printruns = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300];
    const voucher = ref('');
    const freeOrder = ref(props.menu.attributes.data.freeOrder);
    const clickFreeOrder = (event) => {
      if (props.menu.attributes.data.voucher && props.menu.attributes.data.voucher.length > 0 && event.target.checked) {
        emit('update:data', { name: 'voucher', value: null });
      }

      emit('update:data', event);
    };

    const formatPrice = (price) => {
      const formattedPrice = price.toFixed(2).replace('.', ',') + ' €';
      return formattedPrice;
    };

    return {
      bindings,
      formats,
      laminations,
      menuTitle,
      printruns,
      voucher,
      deliveryDate,
      freeOrder,
      clickFreeOrder,
      formatPrice,
    };
  },
};
</script>

<style lang="scss" scoped></style>
